import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "navbar flex row-between col-center"
  }, [_c('div', [_c('hamburger', {
    staticClass: "hamburger-container",
    attrs: {
      "is-active": _vm.sidebar.opened
    },
    on: {
      "toggleClick": _vm.toggleSideBar
    }
  }), _c('breadcrumb', {
    staticClass: "breadcrumb-container"
  })], 1), _c('div', {
    staticClass: "right-menu pr10"
  }, [_c('el-dropdown', {
    staticClass: "avatar-container",
    attrs: {
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "avatar-wrapper flex"
  }, [_c('div', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(_vm.name))]), _c('i', {
    staticClass: "el-icon-caret-bottom"
  })]), _c('el-dropdown-menu', {
    staticClass: "user-dropdown",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('el-dropdown-item', [_vm._v(" 首页 ")])], 1), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.logout.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("退出登录")])])], 1)], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };